import React from 'react';
import { useAnalytics, useScrollTracking } from '../../hooks/useAnalytics';

/**
 * Analytics Wrapper Component
 * Automatically tracks page views and scroll behavior for wrapped content
 */
const AnalyticsWrapper = ({ 
  children, 
  contentType = 'page', 
  contentId = null, 
  contentSlug = null,
  enableScrollTracking = true 
}) => {
  // Track page view and interactions
  const { trackInteraction, trackCustomEvent } = useAnalytics(contentType, contentId, contentSlug);
  
  // Track scroll depth if enabled
  if (enableScrollTracking) {
    useScrollTracking(contentType, contentId);
  }

  return (
    <div data-analytics-content-type={contentType} data-analytics-content-id={contentId}>
      {children}
    </div>
  );
};

export default AnalyticsWrapper;